export interface IScheduledTask {
    id: string;
    type: ScheduledTaskType;
    payload: {
        [key: string]: any
    }
    scheduledTime: number;
    state: ScheduledTaskState;
    error: string;
}

export enum ScheduledTaskState {
    QUEUED = "queued",
    SCHEDULED = "scheduled",
    PROCESSING = "processing",
    COMPLETED = "completed",
    FAILED = "failed",
}

export enum ScheduledTaskType {
    INVOKE_NOTIFICATIONS_PROCESSOR = "invokeNotificationsProcessor",
}
